import React, { forwardRef } from "react";

import { LinkSubBlock as Value } from "@reactivated";

import {
    LinkStyle,
    LinkSubBlock,
    LinkSubBlockClickableMap,
} from "../LinkSubBlock";

interface LinkBlockProps extends React.HTMLAttributes<HTMLElement> {
    id?: string | undefined;
    type?: "linksubblock" | undefined;
    index?: number | undefined;
    value: Value;
    clickableMap?: LinkSubBlockClickableMap<LinkStyle>;
}

/**
 * A thin wrapper around LinkSubBlock that allows it to be used in a Streamfield
 * on its own. Probably won't be its typical use case, though.
 *
 * If this ends up being used in a project, it'll probably need retooled to
 *
 */
export const LinkBlock = forwardRef<HTMLElement, LinkBlockProps>(
    ({ id, type, value, index, clickableMap: clickables, ...props }, ref) => (
        <section {...props} ref={ref}>
            <LinkSubBlock value={value} />
        </section>
    ),
);
